import React, { ReactElement } from 'react'
import { IGatsbyImageData } from 'gatsby-plugin-image'

interface ImageSourceProps {
  className: string
  imageId: string
  image: IGatsbyImageData
}

function ImageSource({ className, imageId, image }: ImageSourceProps): ReactElement {
  return (
    <div className={className}>
      <picture>
        {image.images.sources.map((s, index) => (
          <source key={`source-${imageId}-${index}`} {...s} />
        ))}
        <img
          alt={`image-${imageId}`}
          width={image.width}
          height={image.height}
          {...image.images.fallback}
        />
      </picture>
    </div>
  )
}

export default ImageSource
